import React, { Component } from 'react'
import PropTypes from 'prop-types';
import SelectWithSearch from "./SelectWithSearch"
import APIManager from 'modules/common/apiManager';
export class SelectFilterAPI extends Component {
  constructor(props) {
    super(props);
    this.mAPI = new APIManager();
    this.state = {
      loading: false,
      isLoadingMore: false,
      limit: props.limit || 20,
      options: props.options || [],
      addFilter: props.addFilter || "",
      excludeId: props.excludeId || "",
      page_no: 1,
      hasMore: true,
      search: "",
    }
    this.timer = "";
    this.getData = this.getData.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.loadMore = this.loadMore.bind(this);
    // this.getData();
  }

  componentWillUpdate(nextProps) {
    if (this.state.addFilter !== nextProps.addFilter) {
      this.setState({ addFilter: nextProps.addFilter, options: [], loading: false });
    }
  }

  getData(search, page_no = 1) {
    const { dataUrl, dataLabel, dataValue, filter, latestFirst } = this.props
    let latest = latestFirst ? "&orderBy=create_at&order=DESC" : "";
    let _this = this;
    let searchQuery = "";
    if (search) {
      searchQuery = `&search=${search}`;
    }
    if (filter) {
      searchQuery += `&${filter}`;
    }
    if (page_no === 1) {
      _this.setState({ loading: true });
    } else {
      _this.setState({ isLoadingMore: true });
    }
    this.mAPI.sendGetAPI(
      `${dataUrl}?limit=${this.state.limit}&page_no=${page_no}${searchQuery}${_this.state.addFilter || ""}${latest || ""}`,
      data => {
        if (data && data.data) {
          // that.setState({ listData: data.data });
          let options = [];
          const nextCursor = data.nextCursor ? data.nextCursor : "";
          data.data.map(data => {

            const value = dataValue && data[dataValue] ? data[dataValue] : data._id || "";
            console.log("value", value);
            console.log("this.state.excludeId", this.state.excludeId);
            if (this.state.excludeId && value === this.state.excludeId) {
              return;
            }

            options.push({
              value: dataValue && data[dataValue] ? data[dataValue] : data._id || "",
              data: data,
              label: dataLabel && data[dataLabel] ? data[dataLabel] : data.name || "",
              nextCursor: nextCursor || ""
            });
          });
          _this.setState((prevState) => ({
            "options": page_no === 1 ? options : [...prevState.options, ...options],
            loading: false,
            isLoadingMore: false,
            hasMore: data.data.length >= _this.state.limit
          }));
        } else {
          _this.setState((prevState) => ({
            "options": page_no === 1 ? [] : prevState.options,
            loading: false,
            isLoadingMore: false,
            hasMore: false
          }));
        }
      },
      (error, data) => {
        _this.setState((prevState) => ({
          "options": page_no === 1 ? [] : prevState.options,
          loading: false,
          isLoadingMore: false,
          hasMore: false
        }));
      },
      this.props.global === true ? "public" : ""
    );
  }
  loadMore() {
    if (!this.state.loading && !this.state.isLoadingMore && this.state.hasMore) {
      const nextPage = this.state.page_no + 1;
      this.setState({ page_no: nextPage }, () => {
        this.getData(this.state.search, nextPage);
      });
    }
  }
  onSearch(search) {
    let _this = this;
    search = search == "reload" ? "" : search;
    clearTimeout(this.timer);
    _this.setState({ "loading": true, search: search, page_no: 1 })
    _this.timer = setTimeout(() => {
      _this.getData(search, 1);
    }, 350)
  }

  render() {
    const { selected, label, name, onSelect, multi, initialValues, showAvatar, ...extraProp } = this.props
    return (
      <SelectWithSearch
        loading={this.state.loading}
        initialValues={initialValues}
        selectedValues={selected}
        totalOptions={this.state.options}
        label={label}
        onSelect={onSelect}
        name={name}
        search={this.onSearch}
        multi={multi}
        customOption=""
        showAvatar={showAvatar || false}
        onMenuScrollToBottom={this.loadMore}
        {...extraProp}
      />
    )
  }
}
SelectFilterAPI.contextTypes = {
  __: PropTypes.func
};

export default SelectFilterAPI;



// WEBPACK FOOTER //
// src/modules/common/components/form/SelectFilterAPI.js